import { render, staticRenderFns } from "./ContactSimple.vue?vue&type=template&id=6fd2e7fb&"
import script from "./ContactSimple.vue?vue&type=script&lang=js&"
export * from "./ContactSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports